import type { Step } from '@/components/wizard/Step';

import type { CreateSqlEngineWizardState } from './createSqlEngineWizardState';
import { CreateSqlEngineStep } from './steps/CreateSqlEngineStep';

export const CreateSqlEngineFlow: Step<CreateSqlEngineWizardState> = {
  id: 'create_sql_engine',
  Component: CreateSqlEngineStep,
};
